import { render, staticRenderFns } from "./ImageLightBox.vue?vue&type=template&id=68c42543&scoped=true&"
import script from "./ImageLightBox.vue?vue&type=script&lang=js&"
export * from "./ImageLightBox.vue?vue&type=script&lang=js&"
import style0 from "./ImageLightBox.vue?vue&type=style&index=0&id=68c42543&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "68c42543",
  null
  
)

export default component.exports